import React, { useState, useEffect } from 'react';
import {
  Widget,
  MasterDetailForm,
  Row,
  InlineEditColumnProps,
  Table,
  Button,
  Form,
  FormInput,
  Col,
  FormResetButton,
} from '@digital/ui';
import { Collapse, Icon } from 'antd';
import { ContratadoRequisicaoCompraServico } from '@app/api/projeto';

interface FormResumoContratadoProps {
  contratadoRequisicaoCompraServico: ContratadoRequisicaoCompraServico[];
  style: any;
}

const { Panel } = Collapse;

const FormTableContratadoRequisicaoCompraServico = (props: FormResumoContratadoProps) => {
  const { contratadoRequisicaoCompraServico, style } = props;

  const [valorTotal, setValorTotal] = useState<string>();

  useEffect(() => {
    const getData = () => {
      if (contratadoRequisicaoCompraServico.length > 0) {
        var requisitado = contratadoRequisicaoCompraServico[contratadoRequisicaoCompraServico.length - 1];
        if (requisitado) {
          setValorTotal(requisitado.distribuidoTotalFormatado);
        }
      } else {
        setValorTotal('');
      }
    };

    getData();
  }, [contratadoRequisicaoCompraServico]);

  const customColumns = () => {
    return [
      {
        title: 'N',
        dataIndex: 'index',
        width: '1%',
      },
      {
        title: 'RC',
        dataIndex: 'contratadoCompraNumero',
        width: '2%',
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <Form>
            <Row>
              <FormInput
                placeholder="Pesquisar OI"
                name="contratadoCompraNumero"
                style={{ marginTop: '15px' }}
                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                onPressEnter={() => {
                  if (typeof confirm === 'function') confirm();
                }}
              />
            </Row>
            <Row>
              <Col span={6}>
                <Button
                  type="primary"
                  style={{ marginLeft: '5px' }}
                  onClick={() => {
                    if (typeof confirm === 'function') confirm();
                  }}
                  icon="commons-search"
                  size="small">
                  Pesquisar
                </Button>
              </Col>
              <Col span={6}>
                <FormResetButton
                  size="small"
                  style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                  beforeReset={() => {
                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                  }}>
                  Limpar
                </FormResetButton>
              </Col>
            </Row>
          </Form>
        ),
        filterIcon: filtered => {
          const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
          return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
        },
        onFilter: (value, record) => {
          return record.contratadoCompraNumero !== undefined &&
            record.contratadoCompraNumero
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase())
        }
      },
      {
        title: 'RC Seq',
        dataIndex: 'contratadoCompraSeq',
        width: '10%',
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <Form>
            <Row>
              <FormInput
                placeholder="Pesquisar OI"
                name="contratadoCompraSeq"
                style={{ marginTop: '15px' }}
                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                onPressEnter={() => {
                  if (typeof confirm === 'function') confirm();
                }}
              />
            </Row>
            <Row>
              <Col span={6}>
                <Button
                  type="primary"
                  style={{ marginLeft: '5px' }}
                  onClick={() => {
                    if (typeof confirm === 'function') confirm();
                  }}
                  icon="commons-search"
                  size="small">
                  Pesquisar
                </Button>
              </Col>
              <Col span={6}>
                <FormResetButton
                  size="small"
                  style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                  beforeReset={() => {
                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                  }}>
                  Limpar
                </FormResetButton>
              </Col>
            </Row>
          </Form>
        ),
        filterIcon: filtered => {
          const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
          return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
        },
        onFilter: (value, record) => {
          return record.contratadoCompraSeq !== undefined &&
            record.contratadoCompraSeq
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase())
        }
      },
      {
        title: 'Narrativa',
        dataIndex: 'narrativa',
        width: '42%',
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <Form>
            <Row>
              <FormInput
                placeholder="Pesquisar OI"
                name="narrativa"
                style={{ marginTop: '15px' }}
                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                onPressEnter={() => {
                  if (typeof confirm === 'function') confirm();
                }}
              />
            </Row>
            <Row>
              <Col span={6}>
                <Button
                  type="primary"
                  style={{ marginLeft: '5px' }}
                  onClick={() => {
                    if (typeof confirm === 'function') confirm();
                  }}
                  icon="commons-search"
                  size="small">
                  Pesquisar
                </Button>
              </Col>
              <Col span={6}>
                <FormResetButton
                  size="small"
                  style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                  beforeReset={() => {
                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                  }}>
                  Limpar
                </FormResetButton>
              </Col>
            </Row>
          </Form>
        ),
        filterIcon: filtered => {
          const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
          return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
        },
        onFilter: (value, record) => {
          return record.narrativa !== undefined &&
            record.narrativa
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase())
        }
      },
      {
        title: 'No Projeto',
        dataIndex: 'valorDistribuidoFormatado',
        key: 'valorTotalCurrency',
        align: 'center',
        children: [
          {
            title: `${valorTotal || ''}`,
            dataIndex: 'valorDistribuidoFormatado',
            width: '15%',
            align: 'center',
          },
        ],
      },
      {
        title: 'OC',
        dataIndex: 'contratadoCompraOc',
        width: '10%',
        align: 'center',
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <Form>
            <Row>
              <FormInput
                placeholder="Pesquisar OI"
                name="contratadoCompraOc"
                style={{ marginTop: '15px' }}
                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                onPressEnter={() => {
                  if (typeof confirm === 'function') confirm();
                }}
              />
            </Row>
            <Row>
              <Col span={6}>
                <Button
                  type="primary"
                  style={{ marginLeft: '5px' }}
                  onClick={() => {
                    if (typeof confirm === 'function') confirm();
                  }}
                  icon="commons-search"
                  size="small">
                  Pesquisar
                </Button>
              </Col>
              <Col span={6}>
                <FormResetButton
                  size="small"
                  style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                  beforeReset={() => {
                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                  }}>
                  Limpar
                </FormResetButton>
              </Col>
            </Row>
          </Form>
        ),
        filterIcon: filtered => {
          const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
          return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
        },
        onFilter: (value, record) => {
          return record.contratadoCompraOc !== undefined &&
            record.contratadoCompraOc
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase())
        }
      },
      {
        title: 'PCM',
        dataIndex: 'pedidoPcm',
        width: '10%',
        align: 'center',
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <Form>
            <Row>
              <FormInput
                placeholder="Pesquisar OI"
                name="pedidoPcm"
                style={{ marginTop: '15px' }}
                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                onPressEnter={() => {
                  if (typeof confirm === 'function') confirm();
                }}
              />
            </Row>
            <Row>
              <Col span={6}>
                <Button
                  type="primary"
                  style={{ marginLeft: '5px' }}
                  onClick={() => {
                    if (typeof confirm === 'function') confirm();
                  }}
                  icon="commons-search"
                  size="small">
                  Pesquisar
                </Button>
              </Col>
              <Col span={6}>
                <FormResetButton
                  size="small"
                  style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                  beforeReset={() => {
                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                  }}>
                  Limpar
                </FormResetButton>
              </Col>
            </Row>
          </Form>
        ),
        filterIcon: filtered => {
          const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
          return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
        },
        onFilter: (value, record) => {
          return record.pedidoPcm !== undefined &&
            record.pedidoPcm
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase())
        }
      },
      {
        title: 'CT/PCS',
        dataIndex: 'pedidoCtPcs',
        width: '10%',
        align: 'center',
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <Form>
            <Row>
              <FormInput
                placeholder="Pesquisar OI"
                name="pedidoCtPcs"
                style={{ marginTop: '15px' }}
                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                onPressEnter={() => {
                  if (typeof confirm === 'function') confirm();
                }}
              />
            </Row>
            <Row>
              <Col span={6}>
                <Button
                  type="primary"
                  style={{ marginLeft: '5px' }}
                  onClick={() => {
                    if (typeof confirm === 'function') confirm();
                  }}
                  icon="commons-search"
                  size="small">
                  Pesquisar
                </Button>
              </Col>
              <Col span={6}>
                <FormResetButton
                  size="small"
                  style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                  beforeReset={() => {
                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                  }}>
                  Limpar
                </FormResetButton>
              </Col>
            </Row>
          </Form>
        ),
        filterIcon: filtered => {
          const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
          return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
        },
        onFilter: (value, record) => {
          return record.pedidoCtPcs !== undefined &&
            record.pedidoCtPcs
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase())
        }
      },
    ] as InlineEditColumnProps<ContratadoRequisicaoCompraServico>[];
  };

  return (
    <>
      <Collapse
        bordered={false}
        defaultActiveKey={['2']}
        expandIcon={() => <Icon type="arrows-right_4" />}
        style={style}>
        <Panel key="2" header="ITENS DE REQUISIÇÃO DE COMPRA DE SERVIÇO (CONTRATO/PCS) - OUTROS" style={{ border: 0 }}>
          <MasterDetailForm>
            <Widget
              actions={[
                <Button
                  title="Distribuir contratado serviço"
                  type="primary"
                  icon="commons-search"
                  onClick={() => {
                    window.location.href = `/contratopsc`;
                  }}
                />,
              ]}>
              <Row>
                <Table
                  rowKey="index"
                  columns={customColumns()}
                  id={'584c4a95-ae05-45a0-9665-aba3e5ec3f60'}
                  dataSource={contratadoRequisicaoCompraServico}
                  pagination={
                    {
                      pageSize: 5,
                      onChange: (() => {
                        document.getElementById("584c4a95-ae05-45a0-9665-aba3e5ec3f60").scrollIntoView();
                      })
                    }
                  }
                />
              </Row>
            </Widget>
          </MasterDetailForm>
        </Panel>
      </Collapse>
    </>
  );
};

export default FormTableContratadoRequisicaoCompraServico;
